export const onlinePanel = {
    meta: {
        title: 'Online board of departures and arrivals of Utair flights - flight status on the official website of "UTair" airlines',
        description:
            'Расписание рейсов авиакомпании «ЮТэйр». Онлайн-табло вылетов ' +
            'и прилётов рейсов Utair. Узнать статус рейса на официальном сайте авиакомпании.',
    },
};
